import { useMemo } from 'react';

import { useCurrentWorkspacePaidStatusFragment } from './CurrentWorkspaceOfferingFragment.generated';

export const useWorkspaceHasRedeemedReferralPromotion = (
  workspaceId: string,
) => {
  const { data: workspacePaidStatusData } =
    useCurrentWorkspacePaidStatusFragment({
      from: { id: workspaceId },
    });

  return useMemo(
    () =>
      workspacePaidStatusData?.credits.some(
        (credit) => credit.type === 'promotion' && credit.via === 'ppreferral',
      ),
    [workspacePaidStatusData],
  );
};
